import { useEffect } from "react";
import ChangeLog from "../data/change-log.json"
import ReactGA from "react-ga4"
import { PAGE_TITLE } from "../helpers";
import { Card, Container } from "react-bootstrap";

const MarkdownPage = () => {
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/Change-log",
    })
    document.title = `Changelog ${PAGE_TITLE}`;
  }, [])
  return (
    <Container fluid>
      <Card className="mt-5" style={{ padding: '20px', minHeight: "90vh" }} >
        {
          ChangeLog?.map((release, index) => (
            <div key={index} className="mb-4">
              {/* Version and Date */}
              <h2>
                {release?.version && (
                  <span className="fw-bold">
                    {release.version}
                  </span>
                )}
                {release?.date && (
                  <span className="fw-light ms-2">
                    {release.date}
                  </span>
                )}
              </h2>

              {/* Updates */}
              {Array.isArray(release?.updates) && release.updates.map((update, updateIndex) => (
                <div key={updateIndex} className="mt-3">
                  {/* Header */}
                  {update?.header && (
                    <h4 className="fw-semibold">{update.header}</h4>
                  )}

                  {/* SubHeader */}
                  {update?.subHeader && (
                    <p className="fw-light mb-2">
                      {update.subHeader}
                    </p>
                  )}

                  {/* points */}
                  {Array.isArray(update?.points) && update.points.map((menu, menuIndex) => (
                    <ul key={menuIndex} className="ps-4 mb-3">
                      <li>
                        {menu?.title && <strong>{menu.title}:</strong>} {menu?.description}

                        {/* Subpoints */}
                        {Array.isArray(menu?.subpoints) && menu.subpoints.length > 0 && (
                          <ul className="ps-3 mt-2">
                            {menu.subpoints.map((submenu, subIndex) => (
                              <li key={subIndex} className="list-circle">
                                {submenu?.title && <strong>{submenu.title}:</strong>} {submenu?.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    </ul>
                  ))}
                </div>
              ))}
            </div>
          ))
        }
      </Card >
    </Container>
  );
};

export default MarkdownPage;
